export default {
  /**
   * Parse JWT, to get some data out of it, using Buffer instead of atob to make it node-friendly
   * @param  {string} token JWT
   * @return {object} parsed JWT
   */
  parse(token, encoding = 'binary') {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');

    // Use globalThis to check if Buffer exists (in nodejs world)
    // eslint-disable-next-line no-undef
    if (globalThis.Buffer)
      return JSON.parse(Buffer.from(base64, 'base64').toString(encoding)) || {};

    return JSON.parse(atob(base64).toString(encoding)) || {};
  },
  /**
   * Check if the DRMToday JWT is still valid.
   * @param {Object} token JWT.
   */
  checkIfDRMTodayTokenValid(token) {
    try {
      const decodedToken = this.parse(token) ?? {};
      const { iat } = decodedToken;
      if (!iat) return false;
      const diff = Date.now() - iat * 1000;
      return diff < 10 * 60 * 1000;
    } catch (error) {
      return false;
    }
  },

  /**
   * Check if the JWT is still valid.
   * @param {Object} token JWT.
   * @returns {Boolean}
   */
  isTokenValid(token) {
    const decodedToken = this.parse(token);
    const { exp } = decodedToken;
    const expDate = new Date(exp * 1000);

    return expDate > new Date();
  },

  /**
   * Check if JWT
   * @param {string} accessToken
   * @return boolean
   */
  isJWT(accessToken) {
    if (typeof accessToken !== 'string') return false;
    return accessToken.split('.').length === 3;
  },
};
